export const RESOLUTIONS = {
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1200,
  xxlarge: 2560
};
